import React from 'react';
import { useSelector } from 'react-redux';
import { SkillCard, TypeRow } from 'components';
import { SessionTargetGridCard } from './sessionCards';
import { renderGoalTypes, useModal } from 'utils';
import { GoalDetails } from 'fragments';

export const SessionGoalGridTargets = ({ filteredListData }) => {
    const sessionById = useSelector((state) => state.session.sessionById);
    const notPinnedGoals = filteredListData.filter((i) => !i?.pinned) || [];
    const { open } = useModal();

    return (
        <div>
            <div style={{ padding: '8px 16px' }}>
                {!!notPinnedGoals?.length &&
                    notPinnedGoals?.map((item) => (
                        <div key={item?.goal?.id} className="not-pinned-goals-wrapper">
                            <div className="space-between" style={{ gap: 12, marginBottom: 16 }}>
                                <div className="flex-align-center" style={{ gap: 12 }}>
                                    <button
                                        className="goal-link-btn"
                                        onClick={() =>
                                            open(
                                                <GoalDetails
                                                    goalId={item?.goal?.id}
                                                    requestParams={{ clientId: sessionById?.appt?.client?.id }}
                                                    clientId={sessionById?.appt?.client?.id}
                                                    viewOnly
                                                />
                                            )
                                        }
                                    >
                                        {item?.goal?.name}
                                    </button>

                                    <SkillCard type={item?.goal?.type} />
                                </div>

                                <div className="flex-align-center" style={{ gap: 12 }}>
                                    <div className="correct-goal-box">{renderGoalTypes(item?.goal?.dataType)}</div>
                                    {/*<button style={{ width: 36, height: 36 }} className="session-gray-action-btn-box">*/}
                                    {/*    <img src={Images.infoCircle} alt="filter" />*/}
                                    {/*</button>*/}
                                </div>
                            </div>
                            <div className="not-pinned-targets-box" style={{ gap: 16 }}>
                                {item?.goal?.targets?.map((i) => (
                                    <div key={i?.id}>
                                        <SessionTargetGridCard item={i} goal={item?.goal} />
                                    </div>
                                ))}
                            </div>
                        </div>
                    ))}
            </div>
        </div>
    );
};
